import * as React from 'react'
import MUIButton from '@mui/material/Button'

const Button = (props) => <MUIButton {...props} />

export default Button
